

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"27","height":"18"}, rest), [h('g', {"fill":"#FFFFFF","fill-rule":"evenodd"}, [h('path', {"d":"m1.514.909 12.057 7.234a1 1 0 0 1 0 1.714L1.514 17.091A1 1 0 0 1 0 16.234V1.766A1 1 0 0 1 1.514.91Z"}, []), h('path', {"d":"m13.514.909 12.057 7.234a1 1 0 0 1 0 1.714l-12.057 7.234A1 1 0 0 1 12 16.234V1.766A1 1 0 0 1 13.514.91Z"}, [])])]);
};

        